export var Spacing;
(function (Spacing) {
    Spacing["OFF"] = "0";
    Spacing["XXS"] = "0.25rem";
    Spacing["XS"] = "0.5rem";
    Spacing["S"] = "1rem";
    Spacing["M"] = "1.5rem";
    Spacing["L"] = "2rem";
    Spacing["XL"] = "2.5rem";
    Spacing["XXL"] = "5rem";
})(Spacing || (Spacing = {}));
export var Color;
(function (Color) {
    Color["PRIMARY"] = "#e60000";
    Color["SECONDARY"] = "#4A4D4E";
    Color["LIGHT"] = "#f5f5f5";
    Color["DARK"] = "#25282B";
    Color["SUCCESS"] = "#009900";
    Color["DANGER"] = "#E60000";
    Color["WARNING"] = "#EB9700";
    Color["INFO"] = "#AFAFAF";
    Color["GRAY_100"] = "#F4F4F4";
    Color["GRAY_200"] = "#EBEBEB";
    Color["GRAY_300"] = "#CCCCCC";
    Color["GRAY_400"] = "#AFAFAF";
    Color["GRAY_500"] = "#999999";
    Color["GRAY_600"] = "#666666";
    Color["GRAY_700"] = "#333333";
    Color["GRAY_800"] = "#222222";
    Color["GRAY_900"] = "#000000";
    Color["BLACK"] = "#000000";
    Color["LIGHTBLUE"] = "#CCEFF4";
    Color["TURQOUISE"] = "#007C92";
    Color["AQUA_BLUE"] = "#00B0CA";
    Color["AUBERGINE"] = "#5E2750";
    Color["RED_VIOLET"] = "#9C2AA0";
    Color["FRESH_ORANGE"] = "#EB9700";
    Color["LEMON_YELLOW"] = "#FECB00";
    Color["SPRING_GREEN"] = "#A8B400";
    Color["DARK_RED"] = "#BD0000";
    Color["MAROON"] = "#990000";
    Color["WHITE"] = "#FFFFFF";
})(Color || (Color = {}));
export var Gradient;
(function (Gradient) {
    Gradient["RED_LIGHT"] = "linear-gradient(45deg, #A90000 0%, #E60000 48.96%, #FF0000 100%)";
    Gradient["RED_DARK"] = "linear-gradient(45deg, #990000 0%, #E60000 100%)";
    Gradient["PURPLE"] = "linear-gradient(45deg, #5E2750 0%, #9C2AA0 100%)";
    Gradient["MONOCHROME"] = "linear-gradient(45deg, #999999 0%, #CCCCCC 100%)";
    Gradient["YELLOW"] = "linear-gradient(45deg, #EB9700 0%, #FECB00 100%)";
    Gradient["GREEN"] = "linear-gradient(45deg, #009900 0%, #A8B400 100%)";
    Gradient["BLUE"] = "linear-gradient(45deg, #007C92 0%, #00B0CA 100%)";
})(Gradient || (Gradient = {}));
export var FontLevels;
(function (FontLevels) {
    FontLevels["LEVEL_1"] = "font-size: 2.813rem; line-height: 3.125rem;";
    FontLevels["LEVEL_2"] = "font-size: 2.313rem; line-height: 2.5rem;";
    FontLevels["LEVEL_3"] = "font-size: 1.938rem; line-height: 2.125rem;";
    FontLevels["LEVEL_4"] = "font-size: 1.625rem; line-height: 1.813rem;";
    FontLevels["LEVEL_5"] = "font-size: 1.375rem; line-height: 1.625rem;";
    FontLevels["LEVEL_6"] = "font-size: 1.125rem; line-height: 1.5rem;";
    FontLevels["LEVEL_7"] = "font-size: 1rem; line-height: 1.375rem;";
    FontLevels["LEVEL_8"] = "font-size: 0.875rem; line-height: 1.125rem;";
    FontLevels["LEVEL_9"] = "font-size: 0.75rem; line-height: 1rem;";
    FontLevels["BODY"] = "font-size: 1.125rem; line-height: 1.5rem;";
    FontLevels["BODY_MOBILE"] = "font-size: 1rem; line-height: 1.375rem;";
})(FontLevels || (FontLevels = {}));
export var Breakpoint;
(function (Breakpoint) {
    Breakpoint[Breakpoint["XS"] = 0] = "XS";
    Breakpoint[Breakpoint["SM"] = 480] = "SM";
    Breakpoint[Breakpoint["MD"] = 768] = "MD";
    Breakpoint[Breakpoint["L"] = 1024] = "L";
    Breakpoint[Breakpoint["XL"] = 1200] = "XL";
})(Breakpoint || (Breakpoint = {}));
export const gridTheme = {
    gridColumns: 12,
    breakpoints: {
        xs: Breakpoint.XS,
        sm: Breakpoint.SM,
        md: Breakpoint.MD,
        lg: Breakpoint.L,
        xl: Breakpoint.XL,
        xxl: 9999,
    },
    row: {
        padding: 12,
    },
    col: {
        padding: 12,
    },
    container: {
        padding: 32,
        maxWidth: {
            xs: Breakpoint.SM,
            sm: Breakpoint.MD,
            md: Breakpoint.L,
            lg: 1200,
            xl: 1200,
            xxl: 1200, // xxl is not used
        },
    },
};
//# sourceMappingURL=models.js.map